import { getMonitoringEventsByFarm } from '../../../services/farmMapping/monitoring/monitoringEvents/getMonitoringEvents'
import { queryKeys } from '../../../hooks/data/queryKeys'
import { queryClient } from '../../../queryClient'

export async function getMonitoringEvents({ farmId }: { farmId: string }) {
  // fetchQuery for the same reason as getMonitoringSites, here and in the strata and paddock
  // getters: an entry a write invalidated while nothing watched it must be re-read.
  const monitoringEvents = await queryClient.fetchQuery({
    queryKey: queryKeys.monitoringEvents(farmId),
    queryFn: ({ signal }) => getMonitoringEventsByFarm({ farmId, signal }),
  })

  const options = monitoringEvents
    .map(event => ({
      id: event.id,
      label: event.name,
      value: event.id,
    }))
    .sort((a, b) => a.label.localeCompare(b.label))

  return options
}
